<template>
	<transition name="slide-fade">
		<div class="auth"
		     v-if="show">
			<button @click="hiddenAuth"
			        v-show="show"></button>
			<h1>{{h1}}</h1>
			<form action=""
			      class="user"
			      v-if="userAuthorize">
				<label for="user"></label>
				<input type="text"
				       id="user"
				       v-if="!itsRoot"
				       placeholder="User"
				       :value="inputUsr"
				       autocomplete="off">
				<input type="password"
				       v-if="!itsRoot"
				       placeholder="password"
				       :value="inputPass"
				       autocomplete="off">
				<label for="operator"
				       v-if="itsRoot"
				>Под каким оператором войти?</label>
				<select name="operator"
				        id="operator"
				        v-model="thisOperator"
				        v-if="itsRoot">
					<option :value="operator.name"
					        v-for="operator in operatorList"
					        :key="operator.display_name">{{operator.name}} ({{operator.display_name}})
					</option>
				</select>
				<input type="submit"
				       @click.prevent="authorized"
				       v-if="!itsRoot"
				       value="Войти">
				<input type="submit"
				       v-if="itsRoot"
				       @click.prevent="confirmOperator"
				       value="Войти">
				<transition name="slide-fade">
					<p v-if="incorrectPass"
					   class="incorrect_pass">{{incorrectPassMessage}}</p>
				</transition>
			</form>
			<form action=""
			      class="userData"
			      @submit.prevent="logout"
			      v-else>
				<label>{{getReqUserRole}}
					<br/>
					Имя пользователя: {{userName}}
				</label>
				<br>
				<label for="oper"
				       v-if="getReqUserRole === 'Администратор уровня Бог'"
				>Сменить оператора?</label>
				<select name="oper"
				        id="oper"
				        v-model="thisOperator"
				        v-if="getReqUserRole === 'Администратор уровня Бог'">
					<option :value="operator.name"
					        v-for="operator in operatorList"
					        :key="operator.display_name">{{operator.name}} ({{operator.display_name}})
					</option>
				</select>
				<p class="ok"
				   v-if="getReqUserRole === 'Администратор уровня Бог'"
				   @click="changeOperator">ok</p>
				<input type="submit"
				       value="Выйти из учетки">
				<input type="button"
				       v-if="getReqUserRole === 'Администратор уровня Бог' || getReqUserRole === 'Power User'"
				       value="Создать нового пользователя" @click="nueUser">
				<input type="button"
				       v-if="getReqUserRole === 'Администратор уровня Бог'"
				       value="Обновление данных пользователей" @click="updateUsers">
				<input type="button"
				       value="Сменить пароль" @click="newPassPopup"
				       v-if="!newpass">
				<label for="oldpass"
				       v-if="newpass">старый пароль</label>
				<input type="password"
				       id="oldpass"
				       v-if="newpass"
				       :disabled="dis"
				       v-model="changesPass.old"
				       placeholder="Старый пароль">
				<label for="newpass"
				       v-if="newpass">новый пароль</label>
				<input type="password"
				       id="newpass"
				       v-if="newpass"
				       :disabled="dis"
				       v-model="changesPass.newP"
				       placeholder="Новый пароль">
				<label for="confirmpass"
				       v-if="newpass">повторите новый пароль</label>
				<input type="password"
				       id="confirmpass"
				       v-if="newpass"
				       :disabled="dis"
				       v-model="changesPass.confirm"
				       placeholder="Повторите новый пароль">
				<input type="button"
				       value="ОК"
				       v-if="newpass"
				       @click="newPass">
				<transition name="slide-fade">
					<p v-if="incorrectPassChange"
					   class="incorrect_pass">пароль не был сохранен</p>
				</transition>
				<transition name="slide-fade">
					<p v-if="correctPassChange"
					   class="incorrect_pass correct_pass">новый пароль сохранен</p>
				</transition>
				<transition name="slide-fade">
					<p v-if="correctNewPass"
					   class="incorrect_pass">пароли не совпадают</p>
				</transition>
			</form>
		</div>
	</transition>
</template>
<script>
	import { performRequest }                       from "../script/ws/wsclient";
	import { mapGetters, mapActions, mapMutations } from "vuex";

	export default {
		name:     "Home",
		data() {
			return {
				h1:                   "Вход в учетную запись",
				show:                 true,
				inputUser:            "",
				inputPassword:        "",
				newpass:              false,
				commandWS:            {
					section: "authorize",
					name:    "authorize"
				},
				dataWS:               {
					login:    "",
					password: ""
				},
				userName:             localStorage.getItem("user"),
				incorrectPass:        false,
				incorrectPassMessage: "не верный логин или пароль",
				incorrectPassChange:  false,
				correctPassChange:    false,
				correctNewPass:       false,
				dis:                  false,
				autocomplete:         [],
				changesPass:          {
					old:     "",
					newP:    "",
					confirm: ""
				},
				operatorList:         [],
				itsRoot:              false,
				thisOperator:         ""
			};
		},
		props:    {
			authorize: String,
			logout:    Function
		},
		computed: {
			...mapGetters([
				"getReqUserRole",
				"getViewUser",
				"getPrevPath"
			]),

			inputUsr() {
				return ( this.inputUser = localStorage["user"] || "" );
			},
			inputPass() {
				return ( this.inputPassword = localStorage["pass"] || "" );
			},
			userAuthorize() {
				if (this.authorize === "Выход") {
					this.h1 = "Учетная запись";
					return false;
				} else {
					this.h1 = "Вход в учетную запись";
					return true;
				}
			}
		},
		mounted() {
			if (!this.userAuthorize && this.getReqUserRole === "Администратор уровня Бог") {
				this.thisOperator = this.getViewUser;
				this.getOperators();
			}
		},
		methods:  {
			...mapActions([
				"setReqUserRole",
				"setSelectedMenu"
			]),
			...mapMutations([
				"setAutocomplete",
				"setOperator",
				"setViewUser",
				"setPrevPath",
				"setUsersApp"
			]),
			nueUser() {
				this.$router.push("/new-user");
			},
			newPassPopup() {
				this.newpass = !this.newpass;
			},
			updateUsers() {
				performRequest({
						section: "authorize",
						name:    "getUserList"
					},
					null,
					a => {
					for (let i = 0; i < a.data.length; i++) {
						if (a.data[i].login === 'root' ) {
							a.data.splice(i, 1)
						}
					}
						this.setUsersApp(a.data);
						this.$router.push("update_users");
					}
				);
			},
			newPass() {
				let old     = this.changesPass.old;
				let newP    = this.changesPass.newP;
				let confirm = this.changesPass.confirm;

				if (newP === confirm) {
					this.dis = true;
					performRequest({
							section: "authorize",
							name:    "updatePassword"
						},
						{
							login:       this.userName,
							password:    old,
							newPassword: confirm
						},
						a => {
							if (a.code === 200) {
								localStorage.setItem("pass", confirm);
								this.newpass           = !this.newpass;
								this.correctPassChange = true;
								this.dis               = false;
								this.changesPass       = {
									old:     "",
									newP:    "",
									confirm: ""
								};
								setTimeout(() => {
									if (this.correctPassChange === true) {
										this.correctPassChange = false;
									}
								}, 2000);
							} else {
								this.incorrectPassChange = true;
								this.dis                 = false;
								setTimeout(() => {
									if (this.incorrectPassChange === true) {
										this.incorrectPassChange = false;
									}
								}, 2000);
							}
						});
				} else {
					this.correctNewPass = true;
					this.dis            = false;
					setTimeout(() => {
						if (this.correctNewPass === true) {
							this.correctNewPass = false;
						}
					}, 2000);
				}
			},
			handler() {
				this.show = false;
				this.$router.push("/menu/dashboard");
				this.$emit("onmenushow", {
					menuShow:   true,
					buttonExit: "Выход",
					user:       this.dataWS.login
				});
			},
			confirmOperator() {
				if (this.thisOperator !== "") {
					this.setViewUser(this.thisOperator);
					this.handler();
				}
			},
			getOperators() {
				performRequest(
					{
						section: "tvcontent.operator",
						name:    "getOperatorList"
					},
					{},
					a => {
						if (a.code === 200) {
							this.operatorList = a.data;
							console.log(a);
						} else {
							console.log("ошибка загрузки списка операторов");
						}
					});
			},
			userRule(a) {
				if (a.code === 403) {
					localStorage.removeItem("user");
					localStorage.removeItem("pass");
					this.incorrectPassMessage = "не верный логин или пароль";
					this.incorrectPass        = true;
				} else if (a.code === 400) {
					this.incorrectPassMessage = "введите логин и пароль";
					this.incorrectPass        = true;
				} else if (a.code === 200) {
					let role = "";
					if (a.data.role === 0) {
						role         = "Администратор уровня Бог";
						this.itsRoot = true;
						this.getOperators();
					} else if (a.data.role === 1) {
						this.setViewUser(a.data.operator);
						role = "Power User";
						this.handler();
					} else if (a.data.role === 2) {
						this.setViewUser(a.data.operator);
						role = "оператор";
						this.handler();
					} else if (a.data.role === 3) {
						this.setViewUser(a.data.operator);
						role = "гость";
						this.handler();
					}
					this.setOperator(a.data.operator);
					console.log(a.data.operator);
					this.setReqUserRole(role);
				}
			},
			hiddenAuth() {
				this.$router.push('/menu/dashboard');
				this.setSelectedMenu("0");
			},
			authorized() {
				let input = document.querySelectorAll(".user input");
				localStorage.setItem("user", input[0].value);
				localStorage.setItem("pass", input[1].value);
				if (this.authorize === "Вход") {
					this.dataWS.login    = localStorage["user"];
					this.dataWS.password = localStorage["pass"];
					performRequest(
						this.commandWS,
						this.dataWS,
						a => {
							this.userRule(a);
							this.setSelectedMenu("0");
						});
				}
			},
			changeOperator() {
				this.setViewUser(this.thisOperator);
				console.log(this.getPrevPath);
				if (this.getPrevPath === "/playlist_edit") {
					this.$router.push("/playlist");
				} else {
					this.hiddenAuth();
				}

			}
		},
		beforeDestroy() {
			this.setPrevPath("");
		}
		// watch:    {
		// 	thisOperator(val) {
		// 		this.setViewUser(val);
		// 	}
		// }
	};
</script>
<style scoped lang="scss">
	.auth {
		position: absolute;
		margin-top: 5rem;
		width: 20rem;
		background-color: rgba(238, 238, 238, 0.8);
		border-radius: 0.5rem;
		right: 50%;
		transform: translateX(50%);
		box-shadow: inset 0 0 5px #333333;
		
		button {
			position: absolute;
			height: 2rem;
			width: 2rem;
			background: transparent url('../../static/close.png') no-repeat center;
			background-size: 75%;
			margin: 2px;
			right: 0;
			border: none;
			cursor: pointer;
			outline: none;
		}
		
		h1 {
			font-size: 1.5rem;
			text-align: center;
			padding-top: 2rem;
			font-weight: normal;
		}
		
		.incorrect_pass {
			margin-top: -0.1rem;
			margin-bottom: 2rem;
			font-size: 1.1rem;
			border: none;
			color: #761112;
			text-align: center;
		}
		.correct_pass {
			color: #4f8b3e;
		}
		.ok {
			margin-top: -10px;
			text-align: center;
			cursor: pointer;
			transition: all .3s;
			&:hover {
				background-color: #fff;
			}
		}
		#oper, #operator {
			transition: all .3s;
			&:hover {
				box-shadow: 0 0 3px green;
			}
		}
		form {
			display: flex;
			flex-direction: column;
			label {
				margin-left: 1rem;
				margin-bottom: -.5rem;
			}
			& input, p, select {
				margin: 1rem;
				border-radius: 3px;
				outline: none;
				height: 1.6rem;
				border: 1px solid #c9c9c9;
				padding-left: 5px;
				
				&:focus {
					box-shadow: 0 0 5px #69bf8f;
				}
			}
			
			& input[type='submit'] {
				background: #bbf291;
				transition: all 0.2s;
				cursor: pointer;
				margin-bottom: 2rem;
				
				&:hover {
					background: #78956b;
					color: white;
				}
				
				&:active {
					box-shadow: 0 0 1rem #967068;
				}
			}
			
			& input[type='button'] {
				background: rgba(154, 203, 121, 0.5);
				transition: all 0.2s;
				cursor: pointer;
				margin-top: 0;
				margin-bottom: 2rem;
				
				&:hover {
					background: #78956b;
					color: white;
					
					&:active {
						box-shadow: 0 0 1rem #967068;
					}
				}
			}
		}
	}
	@media (max-width: 620px) {
		.auth {
			margin-top: 9rem;
		}
	}
	.slide-fade-enter-active {
		transition: all 0.3s ease;
	}
	.slide-fade-leave-active {
		transition: all 0.3s ease;
	}
	.slide-fade-enter, .slide-fade-leave-to {
		transform: translateX(10px);
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/Auth.vue